export const REGISTRATION_URL = "/registration";
export const EXTERNAL_REGISTRATION_URL = "#popup";
export const BUSINESS_LIST_URL = "/business-list";
export const LOGO_URL = "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/JI93Xiiofc34vsFYdfxU/media/68f55ba26b779437405831fa.png";
